module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-gdpr-cookies/gatsby-browser.js'),
      options: {"plugins":[],"googleTagManager":{"trackingId":"GTM-MP97XX5","cookieName":"gatsby-gdpr-google-tagmanager"},"environments":["production","development"]},
    }]
